import consts from '../consts'

const getRegisterLink = (tenant, plan = 'free') => {
  if (tenant.pk !== consts.DEFAULT_CLUB_PK) return '/signup'

  return `/signup/${plan}`
}

export default getRegisterLink
